import {put, call, takeLatest} from 'redux-saga/effects';
import {authenticatedAxios, axios} from '../client';
import {
    CONFIRM_LOGIN, confirmLogin,
    SEND_TEXT, sendText,
    LOGIN, login,
    GET_TOKEN, getToken,
    LOGIN_STEP_1_CONFIRMATION_CODE, loginStep1ConfirmationCode,
    GET_IDP_AUTHENTICATION_URL, getIdpAuthenticationUrl,
    IDP_LOGIN, idpLogin,
    CONFIRM_SOCIAL_LOGIN_ACCOUNT, confirmSocialLoginAccount,
    GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN, getConfirmationCodeForSocialLogin,
    RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN, resendConfirmationCodeForSocialLogin,
    confirmSocialLoginAccountAccountExists,
    CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS, SEND_CONFIRMATION_CODE, sendConfirmationCode,
    GET_USER_IDP_ACCOUNTS, getUserIdpAccounts, LINK_USER_IDP_ACCOUNT, linkUserIdpAccount,
    DELETE_USER_IDP_ACCOUNT, deleteUserIdpAccount
} from "../actions/security";





function* handleDeleteUserIdpAccount({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        yield call(authenticatedAxios.post, `${window.api_url}/idp/delete_idp_account`, {
            idp_service: payload.idpService
        });
        yield put(deleteUserIdpAccount({}, {'sent': true}));

    } catch (error) {
        yield put(deleteUserIdpAccount(error, {}, true));
    }
}
export function* watchDeleteUserIdpAccount() {
    yield takeLatest(DELETE_USER_IDP_ACCOUNT, handleDeleteUserIdpAccount);
}




function* handleLinkUserIdpAccount({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(authenticatedAxios.post, `${window.api_url}/idp/link_idp_account`, {
            idp_service: payload.idpService,
            redirect_uri: payload.redirect_uri,
            idp_data: [
                `code=${payload.code}`,
                `scope=${payload.scope}`,
                `prompt=${payload.prompt}`,
                `authuser=${payload.authuser}`,
                `oauth_token=${payload.oauth_token}`,
                `oauth_verifier=${payload.oauth_verifier}`
            ].join("&")
        });

        yield put(linkUserIdpAccount({
            userIdpAccounts: response.data.data
        }, {'sent': true}));



    } catch (error) {
        yield put(linkUserIdpAccount(error, {}, true));
    }
}
export function* watchLinkUserIdpAccount() {
    yield takeLatest(LINK_USER_IDP_ACCOUNT, handleLinkUserIdpAccount);
}




function* handleGetUserIdpAccounts({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        const response = yield call(authenticatedAxios.get, `${window.api_url}/idp/get_user_idp_accounts`);
        yield put(getUserIdpAccounts({
            userIdpAccounts: response.data.data
        }, {'sent': true}));
    } catch (error) {
        yield put(getUserIdpAccounts(error, {}, true));
    }
}
export function* watchGetUserIdpAccounts() {
    yield takeLatest(GET_USER_IDP_ACCOUNTS, handleGetUserIdpAccounts);
}




function* handleConfirmLogin({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        const params = new URLSearchParams();
        params.append('username', `1${payload.mobile}`);
        params.append('_token', payload.token);
        params.append('g-recaptcha-response', payload.recaptchaToken);

        yield call(axios.post, `${window.react_giftya_base_url}/secure/check-login`, params);

        yield put(confirmLogin({
        }, {'sent': true}));

    } catch (error) {
        yield put(confirmLogin(error, {}, true));
    }
}
export function* watchConfirmLogin() {
    yield takeLatest(CONFIRM_LOGIN, handleConfirmLogin);
}





function* handleGetConfirmationCodeForSocialLogin({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        yield call(axios.post, `${window.api_url}/action_otp/send`, {
            mobile: `1${payload.phone.replace(/^1|\D/g, '')}`,
        });

        yield put(getConfirmationCodeForSocialLogin({}, {'sent': true}));

    } catch (error) {
        yield put(getConfirmationCodeForSocialLogin(error, {}, true));
    }
}
export function* watchGetConfirmationCodeForSocialLogin() {
    yield takeLatest(GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN, handleGetConfirmationCodeForSocialLogin);
}




function* handleResendConfirmationCodeForSocialLogin({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        yield call(axios.post, `${window.api_url}/action_otp/send`, {
            mobile: `1${payload.phone.replace(/^1|\D/g, '')}`,
        });

        yield put(resendConfirmationCodeForSocialLogin({
        }, {'sent': true}));

    } catch (error) {
        yield put(resendConfirmationCodeForSocialLogin(error, {}, true));
    }
}
export function* watchResendConfirmationCodeForSocialLogin() {
    yield takeLatest(RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN, handleResendConfirmationCodeForSocialLogin);
}








function* handleConfirmSocialLoginAccountAccountExists({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        yield call(axios.post, `${window.api_url}/otp/login`, {
            mobile: payload.mobile,
            idp_token: payload.idpToken,
            verification_code: payload.verificationCode
        });

        yield put(confirmSocialLoginAccountAccountExists({
            confirmSocialLoginAccountAccountExistsSuccess: true,
        }, {'sent': true}));

    } catch (error) {
        yield put(confirmSocialLoginAccountAccountExists(error, {}, true));
    }
}
export function* watchConfirmSocialLoginAccountAccountExists() {
    yield takeLatest(CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS, handleConfirmSocialLoginAccountAccountExists);
}






function* handleConfirmSocialLoginAccount({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        yield call(axios.post, `${window.api_url}/idp/register`, {
            name: payload.name,
            surname: payload.surname,
            email: payload.email,
            mobile: payload.mobile,
            idp_token: payload.idpToken,
            verification_code: payload.verificationCode
        });

        yield put(confirmSocialLoginAccount({
            confirmSocialLoginAccountSuccess: true,
        }, {'sent': true}));

    } catch (error) {
        yield put(confirmSocialLoginAccount(error, {}, true));
    }
}
export function* watchConfirmSocialLoginAccount() {
    yield takeLatest(CONFIRM_SOCIAL_LOGIN_ACCOUNT, handleConfirmSocialLoginAccount);
}






function* handleIdpLogin({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(axios.post, `${window.api_url}/login_idp`, {
            idp_service: payload.idpService,
            redirect_uri: payload.redirect_uri,
            idp_data: [
                `code=${payload.code}`,
                `scope=${payload.scope}`,
                `prompt=${payload.prompt}`,
                `authuser=${payload.authuser}`,
                `oauth_token=${payload.oauth_token}`,
                `oauth_verifier=${payload.oauth_verifier}`
            ].join("&")
        });


        // we need this form to submit and grant tokens. We are using the refresh token granted in the API call above
        // to verify the user. Some values below are for form validation purposes only
        const params = new URLSearchParams();
        params.append('gift_ya_confirm_code[_failure_path]', "/secure/login-confirm-fail/12345678901?redirect=/secure/account/received%3FevtLogin%3D1");
        params.append('gift_ya_confirm_code[_target_path]', '/secure/account/received');
        params.append('gift_ya_confirm_code[confirmation_code]', response.data.data.refresh_token);
        params.append('gift_ya_confirm_code[_username]', '12345678901'); //these are just fillers for the form to submit successfully
        params.append('gift_ya_confirm_code[_password]', response.data.data.refresh_token);
        params.append('gift_ya_confirm_code[_token]', 'test'); //these are just fillers for the form to submit successfully
        params.append('g-recaptcha-response', payload.recaptchaToken);
        params.append('is_idp_login', '1');
        params.append('token', response.data.data.token);
        params.append('refresh_token', response.data.data.refresh_token);
        yield call(axios.post, `${window.react_giftya_base_url}/secure/check-login`, params);

        yield put(idpLogin({
            redirect: response.data.redirect,
        }, {'sent': true}));

    } catch (error) {
        yield put(idpLogin(error, {
            idpService: payload.idpService
        }, true));
    }
}
export function* watchIpdLogin() {
    yield takeLatest(IDP_LOGIN, handleIdpLogin);
}




function* handleSendConfirmationCode({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        const params = new URLSearchParams();
        params.append('username', `1${payload.username}`);
        params.append('_token', payload.token);
        params.append('g-recaptcha-response', payload.recaptchaToken);

        yield call(axios.post, `${window.react_giftya_base_url}/login/send-confirmation-code`, params);

        yield put(sendConfirmationCode({
            username: `1${payload.username}`
        }, {'sent': true}));


    } catch (error) {
        yield put(sendConfirmationCode(error, {}, true));
    }
}
export function* watchSendConfirmationCode() {
    yield takeLatest(SEND_CONFIRMATION_CODE, handleSendConfirmationCode);
}




function* handleLoginStep1ConfirmationCode({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const params = new URLSearchParams();
        params.append('username', `1${payload.username}`);
        params.append('_token', payload.token);
        params.append('g-recaptcha-response', payload.recaptchaToken);
        if (payload.redirect) {
            params.append('redirect', payload.redirect);
        }
        const response = yield call(axios.post, `${window.react_giftya_base_url}/login-2`, params, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        yield put(loginStep1ConfirmationCode({
            redirect: response.data.redirect,
        }, {'sent': true}));

    } catch (error) {
        yield put(loginStep1ConfirmationCode(error, {}, true));
    }
}
export function* watchLoginStep1ConfirmationCode() {
    yield takeLatest(LOGIN_STEP_1_CONFIRMATION_CODE, handleLoginStep1ConfirmationCode);
}



function* handleGetIdpAuthenticationUrl({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        const params = new URLSearchParams();
        params.append('idp_service', payload.idpService);
        params.append('redirect_uri', payload.redirectUri);

        const response = yield call(axios.get, `${window.api_url}/idp/get_idp_authentication_url`, {
            params: {
                idp_service: payload.idpService,
                redirect_uri: payload.redirectUri
            }
        });

        yield put(getIdpAuthenticationUrl({
            getIdpAuthenticationUrlUrl: response.data.data.URL,
        }, {'sent': true}));



    } catch (error) {
        yield put(getIdpAuthenticationUrl(error, {}, true));
    }
}
export function* watchGetIdpAuthenticationUrl() {
    yield takeLatest(GET_IDP_AUTHENTICATION_URL, handleGetIdpAuthenticationUrl);
}




function* handleSendText({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }


    try {
        const params = new URLSearchParams();
        params.append('gift_ya_send_code[username]', `1${payload.phoneNumber.replace(/^1|\D/g, '')}`);
        params.append('gift_ya_send_code[_token]', payload.token);
        params.append('g-recaptcha-response', payload.recaptchaToken);

        yield call(axios.post, `${window.react_giftya_base_url}/login`, params, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
    } catch (error) {
        yield put(sendText(error, {}, true));
    }

    yield put(sendText({

    }, {'sent': true}));
}
export function* watchSendText() {
    yield takeLatest(SEND_TEXT, handleSendText);
}



function* handleLogin({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;

    try {

        const params = new URLSearchParams();
        params.append('gift_ya_confirm_code[_username]', `1${payload.username.replace(/^1|\D/g, '')}`);
        params.append('gift_ya_confirm_code[_password]', payload.code.replace(/\D/g, ''));
        params.append('gift_ya_confirm_code[_token]', payload.token);

        response = yield call(axios.post, `${window.react_giftya_base_url}/secure/check-login`, params, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
    } catch (error) {
        yield put(login(error, {}, true));
    }

    yield put(login({
        accessToken: response.data.access_token,
        refreshToken: response.data.refresh_token,
        accountId: response.data.account_id,
    }, {'sent': true}));
}
export function* watchLogin() {
    yield takeLatest(LOGIN, handleLogin);
}



function* handleGetToken({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;

    try {
        response = yield call(axios.get, `${window.react_giftya_base_url}/csrf-token?name=${payload.name}`);
    } catch (error) {
        yield put(getToken(error, {}, true));
    }

    yield put(getToken({
        token: response.data.token
    }, {'sent': true}));
}
export function* watchGetToken() {
    yield takeLatest(GET_TOKEN, handleGetToken);
}
